import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { BaseUserService, waitUntil } from "@smarterplan/ngx-smarterplan-core";
import { ConnectionService } from "../services/connection.service";

@Injectable({
    providedIn: "root",
})
export class ManagerGuard implements CanActivate {
    constructor(
        private userService: BaseUserService,
        private router: Router,
        private awsConnectionService: ConnectionService,
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean | UrlTree> {
        if (!this.awsConnectionService.isConfigured) {
            await waitUntil(() => this.awsConnectionService.isConfigured);
        }
        if (this.awsConnectionService.isAuthenticated) {
            return true;
        }
        return this.router.parseUrl("/notauthorized");
    }
}
